import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect, useState, useRef } from 'react';
import { useSelector } from 'react-redux';
import { motion, AnimatePresence } from 'framer-motion';
import cn from 'classnames';
import useStyles from 'isomorphic-style-loader/useStyles';
import App from 'modules/App';
import styles from './PopUp.pcss';
const PopUp = ({ id, relativeTo, backgroundColor = 'white', noPadding = false, onClose, children })=>{
    if (!process.env.BROWSER) {
        return null;
    }
    const dropdown = useSelector(App.selectors.dropdown);
    const popupRef = useRef(null);
    const [isOpen, setIsOpen] = useState(false);
    useStyles(styles);
    useEffect(()=>{
        const isClosing = isOpen && dropdown !== id;
        setIsOpen(dropdown === id);
        if (isClosing && onClose) {
            onClose();
        }
    }, [
        dropdown
    ]);
    const onClick = (evt)=>{
        evt.stopPropagation();
    };
    const onAnimationStart = ()=>{
        if (!popupRef.current) return;
        const gap = relativeTo ? 4 : 32;
        const documentWidth = window.innerWidth || document.documentElement.clientWidth;
        const rect = popupRef.current.getBoundingClientRect();
        const { width } = rect;
        let { left } = rect;
        let right = documentWidth - rect.right;
        if (relativeTo === 'modal') {
            const container = popupRef.current.closest('.modal__content');
            const containerRect = container.getBoundingClientRect();
            left -= containerRect.left;
            const containerRight = documentWidth - containerRect.right;
            right -= containerRight;
        }
        let popupVector;
        let arrowVector;
        if (right < gap) {
            popupVector = right - gap - width / 2;
            arrowVector = gap - right;
        } else if (left < gap) {
            popupVector = gap - left - width / 2;
            arrowVector = left - gap;
        }
        if (popupVector) {
            popupRef.current.style.setProperty('--popup-vector', `${popupVector}px`);
            popupRef.current.style.setProperty('--arrow-vector', `${arrowVector}px`);
        }
    };
    return /*#__PURE__*/ _jsx(AnimatePresence, {
        children: isOpen ? /*#__PURE__*/ _jsx(motion.div, {
            ref: popupRef,
            initial: {
                opacity: 0
            },
            animate: {
                opacity: 1
            },
            exit: {
                opacity: 0
            },
            transition: {
                ease: 'easeOut',
                duration: 0.15
            },
            className: cn(styles.popup, styles.arrowTop, {
                [styles['popup--stdBg']]: backgroundColor === 'standard'
            }),
            onAnimationStart: onAnimationStart,
            children: /*#__PURE__*/ _jsx("div", {
                className: cn(styles.popupContent, {
                    'p-0': noPadding
                }),
                onClick: onClick,
                children: children
            })
        }) : null
    });
};
export default PopUp;
